import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success: "border-transparent bg-nexus-success text-white hover:bg-nexus-success/80",
        warning: "border-transparent bg-nexus-warning text-white hover:bg-nexus-warning/80",
        new: "border-transparent bg-status-new text-white hover:bg-status-new/80",
        contacted: "border-transparent bg-status-contacted text-white hover:bg-status-contacted/80",
        promised: "border-transparent bg-status-promised text-white hover:bg-status-promised/80",
        paid: "border-transparent bg-status-paid text-white hover:bg-status-paid/80",
        closed: "border-transparent bg-status-closed text-white hover:bg-status-closed/80",
        in_flow: "border-transparent bg-nexus-info text-white hover:bg-nexus-info/80",
        sold: "border-transparent bg-nexus-success text-white hover:bg-nexus-success/80",
        dnc: "border-transparent bg-nexus-danger text-white hover:bg-nexus-danger/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge }
